import { useContext } from 'react';

import { StoreContext } from '../contexts';
import { RootStore } from '../store';

export const useStore = (): RootStore => useContext(StoreContext);
